import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import { get } from 'dpl/shared/utils/object';
import { getArticlePath } from 'dpl/prismic/utils';
import RichText from 'dpl/prismic/components/RichText';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';

export default function CustomLinksLargeTiles({ headline, items }) {
  return (
    <div className="PrismicCustomLinksLargeTiles container">
      <p className="f5 b mb6">{headline}</p>
      <ul className="row">
        {items.map((item, i) => (
          <li className="col-auto col-lg-6 mb6 row no-gutters" key={i}>
            <a
              href={
                get(item, 'link.uid')
                  ? getArticlePath(item.link)
                  : item.link.url
              }
            >
              {get(item, 'image.large.url') && (
                <div className="d-flex flex-row-reverse d-lg-block d-xl-block overflow-hidden no-gutters">
                  <div className="mb2 mb6-lg grow">
                    <SmartImage
                      className="w-100 bg-center cover br1"
                      src={item.image.large.url}
                    />
                  </div>
                  <div className="col-7 col-lg-auto mr2">
                    <p className="f3 f5-lg fw-medium mb2">{item.headline}</p>
                    <div className="PrismicCustomLinksLargeTiles__shortDescription">
                      <RichText content={item.short_description} />
                    </div>
                  </div>
                </div>
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

CustomLinksLargeTiles.propTypes = {
  headline: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      image: PropTypes.shape({
        large: PropTypes.shape({
          url: PropTypes.string
        })
      }),
      short_description: StructuredTextPropTypes,
      url: PropTypes.shape({
        url: PropTypes.string,
        uid: PropTypes.string
      })
    })
  ).isRequired
};
